// Wrapper function to avoid polluting the global scope
(() => {
  // Find the main navigation container. If it doesn't exist, exit.
  const navigationEl = document.querySelector(".product-slider-navigation");
  if (!navigationEl) return;

  // Find the buttons and the dots container.
  const prevButton = navigationEl.querySelector("#prev");
  const nextButton = navigationEl.querySelector("#next");
  const pageDots = navigationEl.querySelector(".page-dots-wrapper");
  if (!pageDots) return;

  // Create an array of dot buttons.
  const dotButtons = Array.from(pageDots.querySelectorAll(".tap-area"));
  if (!dotButtons.length) return;

  // Read current index from DOM based on aria-current
  function getActiveIndex() {
    const idx = dotButtons.findIndex(
      (button) => button.getAttribute("aria-current") === "true"
    );
    return idx === -1 ? 0 : idx;
  }

  let currentIndex = getActiveIndex();

  function scrollToDot(index) {
    const target = dotButtons[index];
    if (!target) return;

    const targetLeft = target.offsetLeft - pageDots.offsetLeft;

    pageDots.scrollTo({
      left: targetLeft,
      behavior: "smooth",
    });
  }

  function updateButtonStates() {
    currentIndex = getActiveIndex();

    if (prevButton) {
      prevButton.disabled = getNextVisibleDotIndex(currentIndex, -1) < 0;
    }

    if (nextButton) {
      nextButton.disabled = getNextVisibleDotIndex(currentIndex, 1) < 0;
    }
  }

  // Navigate to a dot at the specified index via simulated click
  function goToDot(index) {
    index = Math.max(0, Math.min(dotButtons.length - 1, index));

    const dot = dotButtons[index];
    if (!dot) return;

    // Simulate a user click so the underlying slider logic runs
    dot.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
      })
    );

    // After the slider updates aria-current, sync state
    setTimeout(() => {
      updateButtonStates();
      scrollToDot(getActiveIndex());
    }, 0);
  }

  // Returns the next visible dot index in the given direction (+1 or -1), skipping hidden dots
  function getNextVisibleDotIndex(fromIndex, direction) {
    let i = fromIndex + direction;
    while (i >= 0 && i < dotButtons.length) {
      if (!dotButtons[i].hidden) return i;
      i += direction;
    }
    return -1;
  }

  // Add a click handler to the "prev" button (if it exists)
  if (prevButton) {
    prevButton.addEventListener("click", () => {
      const idx = getActiveIndex();
      const prevIdx = getNextVisibleDotIndex(idx, -1);
      if (prevIdx >= 0) {
        goToDot(prevIdx);
      }
    });
  }

  // Add a click handler to the "next" button (if it exists)
  if (nextButton) {
    nextButton.addEventListener("click", () => {
      const idx = getActiveIndex();
      const nextIdx = getNextVisibleDotIndex(idx, 1);
      if (nextIdx >= 0) {
        goToDot(nextIdx);
      }
    });
  }

  // When user clicks on a dot manually, only sync state (no recursive goToDot)
  dotButtons.forEach((button) => {
    button.addEventListener("click", () => {
      // Let the slider update aria-current, then sync
      setTimeout(() => {
        updateButtonStates();
        scrollToDot(getActiveIndex());
      }, 0);
    });
  });

  // Optional: observe aria-current changes if slider updates it programmatically
  const observer = new MutationObserver(() => {
    updateButtonStates();
  });

  dotButtons.forEach((btn) => {
    observer.observe(btn, {
      attributes: true,
      attributeFilter: ["aria-current"],
    });
  });

  // Initial sync
  updateButtonStates();
  scrollToDot(currentIndex);
})();
